<!--
 * @Author: jiangxiang
 * @LastEditors: niuzijie
-->
<template>
<div></div>
</template>

<script>
import * as Api from '@api/base/public'
export default {
  name: 'Transfer',
  data() {
    return {
      shop: ''
    }
  },
  async created() {
    const { hmac = '', shop = '', host = '' } = this.$route.query
    if (hmac && shop && host) {
      this.shop = shop.replace('.myshopify.com', '')
      const shopifyAuthTime = sessionStorage.getItem('shopifyAuthTime')
      if (shopifyAuthTime && new Date().getTime() - shopifyAuthTime <= 3000) {
        // 5s内重复请求就结束
        return false
      }
      sessionStorage.setItem('shopifyAuthTime', new Date().getTime())
      const res = await this.shopifyCheckSign(this.$route.query)
      if (!res) {
        // 校验失败  请求真实性异常
        // this.$message.error('invalid request')
        location.href = `https://${shop}`
      }
    }
    this.init()
  },
  methods: {
    async shopifyCheckSign(params) {
      const { data = false } = await Api.shopifyCheckSign(params)
      return data
    },
    // 初始化
    init() {
      // shopify 生产使用key
      let id = 'e68a85e476e2d139dde2d2da2f59168e'
      if (location.host !== 'vip.jtjms-eg.com') {
        // shopify 非生产使用key
        id = 'b2d687d3beb33e7a020b4f7f7f89839b'
      }
      console.log(this.shop)
      location.href = `https://${this.shop}.myshopify.com/admin/oauth/authorize?client_id=${id}&scope=read_locations,write_fulfillments,write_orders,write_shipping&redirect_uri=${
        location.origin
      }/shopifylogin`
    },
  },
}
</script>

<style>

</style>
